(() => {
  let chips = [...document.querySelectorAll('[data-mayhem-header-vehicle]')];
  const panels = new Map(chips.map(chip => [chip, chip.querySelector('[data-mayhem-header-vehicle-panel]')]));
  const openButtons = new Map(chips.map(chip => [chip, chip.querySelector('[data-mayhem-header-vehicle-open]')]));
  let mobilePickerRequested = false;
  const photoRequests = new Map();
  const photoLookups = new Set();
  const nativePhotoIds = new Map();
  const nativePhotoRequests = new Set();
  const resolveToolbarPhoto = saved => {
    if (!saved?.native || nativePhotoRequests.has(saved.id)) return;
    const resolve = window.TWGFitmentPreview?.resolveVisualizerVehicle;
    if (!resolve) return;
    nativePhotoRequests.add(saved.id);
    resolve().then(binding => {
      // A thumbnail may represent a body option; it never selects a visualizer body or proves fitment.
      const id = binding.vehicleId || binding.candidates?.[0]?.id;
      if (id) nativePhotoIds.set(saved.id, String(id));
      if ((read(localStorage) || read(sessionStorage))?.id === saved.id) update();
    }).catch(() => { nativePhotoRequests.delete(saved.id); });
  };

  window.mayhemGetVehiclePhoto = id => {
    if (!photoRequests.has(id)) {
      const url = new URL('https://api.autosyncstudio.com/vehicles');
      url.searchParams.set('key', 'mayhem');
      url.searchParams.set('f-id', id);
      url.searchParams.set('i-img001', 'true');
      photoRequests.set(id, fetch(url).then(response => {
        if (!response.ok) throw new Error('Vehicle photo unavailable');
        return response.json();
      }).catch(error => { photoRequests.delete(id); throw error; }));
    }
    return photoRequests.get(id);
  };

  const read = store => {
    const native = window.TWGFitmentPreview?.selectedVehicle();
    if (native) return {id:'fg:' + JSON.stringify(native.query), native:true, label:native.label, vehicle:null};
    return null;
  };

  const syncVisualizerLinks = () => {
    const saved = read(localStorage) || read(sessionStorage);
    const selectedId = saved?.native ? window.TWGFitmentPreview?.visualizerVehicleId?.() : saved?.id;
    document.querySelectorAll('a[href*="/pages/visualizer"], a[data-mayhem-original-visualizer-href]').forEach(link => {
      if (link.matches('[data-mayhem-card-view-on-vehicle]') || /view on vehicle/i.test(link.textContent || '')) return;
      const original = link.dataset.mayhemOriginalVisualizerHref || link.getAttribute('href');
      if (!original) return;
      let destination;
      try { destination = new URL(original, location.origin); } catch { return; }
      if (destination.origin !== location.origin || !/\/pages\/visualizer\/?$/.test(destination.pathname) ||
        /vehicle_id=/i.test(destination.hash) || ['wheel', 'sku', 'variant'].some(key => destination.searchParams.has(key))) return;
      if (!link.dataset.mayhemOriginalVisualizerHref) link.dataset.mayhemOriginalVisualizerHref = original;
      if (selectedId) destination.searchParams.set('vehicle_id', selectedId);
      const href = selectedId ? destination.pathname + destination.search + destination.hash : original;
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
  };

  window.addEventListener('twg:visualizer-ready',()=>update());
  window.addEventListener('twg:vehicle-changed',()=>{if(window.TWGFitmentPreview?.selectedVehicle()?.query.provider==='twg_app')window.TWGFitmentPreview.resolveVisualizerVehicle?.().catch(()=>{});});

  const compactVehicleApplication = (value, body = '') => {
    const parts = String(value || '').split(' · ').map(part => part.trim()).filter(Boolean);
    const trim = parts[0] || '';
    const cab = String(body || parts.find(part => /\bcab\b/i.test(part)) || '')
      .replace(/\s+pickup.*$/i, '').trim();
    return [trim, cab].filter(Boolean).join(' · ');
  };

  const close = (chip, restoreFocus = false) => {
    const panel = panels.get(chip);
    if (!panel || panel.hidden) return;
    const surface = panel.closest('[data-mayhem-collection-vehicle-dialog]');
    const opener = panel.mayhemOpener;
    panel.hidden = true;
    window.dispatchEvent(new CustomEvent('mayhem:picker-closed', {detail:{surface:'header'}}));
    chip.mayhemCancelPicker?.();
    if (surface?.open) surface.close();
    panel.setAttribute('role', 'dialog');
    if (panel.parentElement !== chip) chip.appendChild(panel);
    openButtons.get(chip)?.setAttribute('aria-expanded', 'false');
    opener?.setAttribute('aria-expanded', 'false');
    panel.mayhemOpener = null;
    if (restoreFocus) {
      const target = opener?.isConnected && opener.getClientRects().length ? opener :
        [...document.querySelectorAll('[data-mayhem-mobile-vehicle-details], [data-mayhem-mobile-vehicle-select]')].find(node => node.getClientRects().length);
      target?.focus();
    }
  };

  const renderVehicleMedia = (media, saved, photoUrl) => {
    if (!media) return;
    media.hidden = !saved;
    const photo = media.querySelector('img');
    const fallback = media.querySelector('svg');
    if (photoUrl) {
      photo.onload = () => { photo.hidden = false; fallback.hidden = true; };
      photo.onerror = () => { photo.hidden = true; fallback.hidden = false; };
      if (photo.getAttribute('src') !== photoUrl) photo.src = photoUrl;
      if (photo.complete && photo.naturalWidth > 0) { photo.hidden = false; fallback.hidden = true; }
    } else {
      photo.removeAttribute('src');
      photo.hidden = true;
      fallback.hidden = false;
    }
  };

  const update = () => {
    const saved = read(localStorage) || read(sessionStorage);
    const vehicle = saved?.vehicle;
    const photoId = saved?.native ? (window.TWGFitmentPreview?.visualizerVehicleId?.() || nativePhotoIds.get(saved.id)) : saved?.id;
    if (saved?.native && !photoId) resolveToolbarPhoto(saved);
    if (document.querySelector('[data-mayhem-home-toolbar]')) {
      document.documentElement.toggleAttribute('data-mayhem-home-vehicle', Boolean(saved));
    }
    if (saved && photoId && !vehicle?.photoUrl && !photoLookups.has(photoId)) {
      photoLookups.add(photoId);
      window.mayhemGetVehiclePhoto(photoId).then(data => {
        const row = data.Vehicles?.find(item => String(item.Id) === photoId);
        const path = row?.Img001?.['350'] || row?.Img001?.['240'];
        if (!path || !data.ImgUrlBase || (read(localStorage) || read(sessionStorage))?.id !== saved.id || (saved.native && (window.TWGFitmentPreview?.visualizerVehicleId?.() || nativePhotoIds.get(saved.id)) !== photoId)) return;
        try { localStorage.setItem('mayhem:vehicle-photo:' + photoId, new URL(path, data.ImgUrlBase).href); } catch { /* The placeholder remains available. */ }
        update();
      }).catch(() => { /* The picker remains available without a photo. */ });
    }
    const applicationLabel = saved?.native ? saved.label.split(' · ').slice(3).join(' · ') : [compactVehicleApplication(vehicle?.submodel, vehicle?.body), vehicle?.bed].filter(Boolean).join(' · ');
    const label = saved?.native ? saved.label : [vehicle?.year, vehicle?.make, vehicle?.model, applicationLabel]
      .map(part => String(part || '').trim()).filter(Boolean).join(' ') || 'Selected vehicle';
    const shortLabel = saved?.native ? saved.label.split(' · ').slice(0,3).join(' ') : [vehicle?.year, vehicle?.make, vehicle?.model].filter(Boolean).join(' ') || 'Selected vehicle';
    let photoUrl = vehicle?.photoUrl;
    if (!photoUrl && saved) {
      try { photoUrl = localStorage.getItem('mayhem:vehicle-photo:' + photoId); } catch { /* The placeholder remains available. */ }
    }
    const mobileStatus = document.querySelector('[data-mayhem-mobile-vehicle-status]');
    if (mobileStatus) {
      mobileStatus.hidden = false;
      mobileStatus.querySelector('[data-mayhem-mobile-vehicle-select]').hidden = !!saved;
      mobileStatus.querySelector('[data-mayhem-mobile-vehicle-details]').hidden = !saved;
      mobileStatus.querySelector('[data-mayhem-mobile-vehicle-change]').hidden = !saved;
      mobileStatus.querySelector('[data-mayhem-mobile-vehicle-clear]').hidden = !saved;
      const statusName = mobileStatus.querySelector('[data-mayhem-mobile-vehicle-name]');
      if (statusName.textContent !== shortLabel) statusName.textContent = shortLabel;
      const statusApplication = mobileStatus.querySelector('[data-mayhem-mobile-vehicle-application]');
      if (statusApplication.textContent !== applicationLabel) statusApplication.textContent = applicationLabel;
      renderVehicleMedia(mobileStatus.querySelector('[data-mayhem-mobile-vehicle-media]'), saved, photoUrl);
      mobileStatus.querySelector('[data-mayhem-mobile-vehicle-details]').setAttribute('aria-label', `Change ${label}`);
    }
    chips.forEach(chip => {
      chip.querySelector('[data-mayhem-header-vehicle-open]').hidden = !!saved;
      chip.querySelector('[data-mayhem-header-vehicle-selected]').hidden = !saved;
      chip.querySelector('[data-mayhem-header-vehicle-clear]').hidden = !saved;
      const pickerClear = panels.get(chip).querySelector('[data-mayhem-picker-clear]');
      if (pickerClear) pickerClear.hidden = !saved;
      const changeButton = chip.querySelector('[data-mayhem-header-vehicle-change]');
      if (changeButton) changeButton.hidden = !saved;
      const name = chip.querySelector('[data-mayhem-header-vehicle-name]');
      if (name.textContent !== label) name.textContent = label;
      chip.querySelector('.mayhem-header-vehicle__selection').setAttribute('aria-label', `Change ${label}`);
      const application = chip.querySelector('[data-mayhem-header-vehicle-application]');
      if (application) {
        if (name.textContent !== shortLabel) name.textContent = shortLabel;
        if (application.textContent !== applicationLabel) application.textContent = applicationLabel;
      }
      const media = chip.querySelector('[data-mayhem-header-vehicle-media]');
      renderVehicleMedia(media, saved, photoUrl);

    });
    syncVisualizerLinks();
  };

  const fetchAll = async (path, filters, signal, collection) => {
    const rows = [];
    for (let page = 1; page <= 50; page += 1) {
      const url = new URL('https://api.autosyncstudio.com' + path);
      url.searchParams.set('key', 'mayhem');
      url.searchParams.set('p-size', '500');
      url.searchParams.set('p-number', String(page));
      Object.entries(filters).forEach(([key, value]) => url.searchParams.set(key, value));
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('Vehicle choices are unavailable');
      const data = await response.json();
      if (data.Error || !Array.isArray(data[collection])) throw new Error('Vehicle choices are unavailable');
      rows.push(...(collection === 'Vehicles' ? data[collection].map(row => {
        const imagePath = row.Img001?.['350'] || row.Img001?.['240'];
        return { ...row, mayhemPhotoUrl: imagePath && data.ImgUrlBase ? new URL(imagePath, data.ImgUrlBase).href : null };
      }) : data[collection]));
      if (!data.MoreItems) return rows;
    }
    throw new Error('Too many vehicle choices');
  };

  const clearSelection = () => {
    chips.forEach(chip => close(chip));
    for (const store of [localStorage, sessionStorage]) {
      try {
        store.removeItem('mayhem:selected-vehicle-id');
        store.removeItem('mayhem:selected-vehicle');
      } catch (error) { /* Continue with the other storage option. */ }
    }
    window.TWGFitmentPreview?.clearVehicle();
    update();
    window.dispatchEvent(new CustomEvent('mayhem:vehicle-changed', { detail: { id: null, vehicle: null, source: 'header' } }));
  };

  const initializeChip = chip => {
    const openButton = chip.querySelector('[data-mayhem-header-vehicle-open]');
    const panel = panels.get(chip);
    const fields = ['year', 'make', 'model', 'trim', 'vehicle'].map(name => panel.querySelector(`[data-vehicle-field="${name}"]`));
    const [year, make, model, trim, vehicle] = fields;
    const message = panel.querySelector('[data-mayhem-header-vehicle-message]');
    const retry = panel.querySelector('[data-mayhem-header-vehicle-retry]');
    const applyButton = panel.querySelector('[data-mayhem-picker-apply]');
    const placeholders = ['Select year', 'Select make', 'Select model', 'Select trim', 'Select body / bed'];
    const paths = ['/vehicles/years', '/vehicles/makes', '/vehicles/models', '/vehicles'];
    const collections = ['Years', 'Makes', 'Models', 'Vehicles'];
    let currentStage = 0;
    let request = 0;
    let controller;
    let vehicleRows = new Map();
    let searchRemainder = null;
    chip.mayhemPrefillSearch = async input => {
      searchRemainder = null;
      await load(0);
      if (!Array.from(year.options).some(o => o.value === input.year)) return;
      year.value = input.year; resetAfter(0); await load(1);
      const makeOption = Array.from(make.options).find(o => o.value.toLowerCase() === input.make);
      if (!makeOption) return;
      make.value = makeOption.value; resetAfter(1); await load(2);
      const candidate = window.MayhemWheelSearch.modelCandidate(input.remainder, Array.from(model.options).map(o => o.value).filter(Boolean));
      if (!candidate) return;
      const modelOption = Array.from(model.options).find(o => o.value === candidate.value);
      model.value = modelOption.value;
      searchRemainder = candidate.remainder;
      resetAfter(2); await load(3); trim.focus();
    };
    const bodyLabel = panel.querySelector('[data-vehicle-body-label]');
    const showBodyField = show => {
      for (const element of [bodyLabel, vehicle]) {
        element.hidden = !show;
        element.style.display = show ? '' : 'none';
      }
    };
    const sameFitment = (a, b) => Array.isArray(a.Fitments) && Array.isArray(b.Fitments) &&
      JSON.stringify(a.Fitments) === JSON.stringify(b.Fitments) &&
      ['BoltCircle', 'Bore', 'BoreRear', 'LugCount', 'Drw', 'Doors', 'DefaultChassisId']
        .every(key => a[key] === b[key]);
    const distinctVehicles = rows => rows.filter(row => {
      if (row.Bed) return true;
      const alternatives = rows.filter(other => other !== row && other.Bed &&
        (other.Submodel || 'Base') === (row.Submodel || 'Base') && other.Body === row.Body && sameFitment(row, other));
      return alternatives.length !== 1;
    });

    const setOptions = (field, options, placeholder) => {
      field.replaceChildren(new Option(placeholder, ''));
      options.forEach(option => field.add(new Option(option.label, option.value)));
      field.disabled = !options.length;
    };
    const resetAfter = stage => {
      ++request; controller?.abort();
      applyButton.disabled = true;
      fields.slice(stage + 1).forEach((field, index) => setOptions(field, [], placeholders[stage + 1 + index]));
    };
    const bodyOptions = () => {
      const rows = distinctVehicles([...vehicleRows.values()].filter(row => (row.Submodel || 'Base') === trim.value));
      const label = row => {
        const body = String(row.Body || 'Body unspecified').replace(/\s+Pickup$/i, '');
        const bed = String(row.Bed || '').trim();
        return [body, bed || (rows.some(other => other !== row && other.Body === row.Body) ? 'Bed details unavailable' : '')].filter(Boolean).join(' · ');
      };
      const labels = rows.map(label);
      return rows.map((row, index) => ({ value: String(row.Id), label: labels[index] + (labels.indexOf(labels[index]) !== labels.lastIndexOf(labels[index]) ? ` · ID ${row.Id}` : '') }))
        .sort((a, b) => a.label.localeCompare(b.label));
    };
    const load = async stage => {
      message.hidden=false;message.textContent='Vehicle lookup is unavailable. Please refresh and try again.';return;
      controller?.abort();
      const activeController = new AbortController();
      controller = activeController;
      const token = ++request;
      currentStage = stage;
      const target = fields[stage];
      if (stage === 4) {
        const options = bodyOptions();
        setOptions(target, options, placeholders[stage]);
        showBodyField(options.length > 1);
        message.textContent = options.length ? '' : 'No vehicles found for this selection.';
        retry.hidden = true;
        if (options.length === 1) {
          target.value = options[0].value;
          target.dispatchEvent(new Event('change'));
        }
        return;
      }
      const filters = {};
      if (stage >= 1) filters['f-year'] = year.value;
      if (stage >= 2) filters['f-make'] = make.value;
      if (stage >= 3) filters['f-model'] = model.value;
      if (stage === 3) { filters['i-img001'] = 'true'; filters['i-fitments'] = '1'; }
      setOptions(target, [], 'Loading ' + ['years', 'makes', 'models', 'trims'][stage] + '…');
      message.textContent = '';
      retry.hidden = true;
      let timedOut = false;
      const timer = setTimeout(() => { timedOut = true; activeController.abort(); }, 20000);
      try {
        const rows = await fetchAll(paths[stage], filters, activeController.signal, collections[stage]);
        if (token !== request || panel.hidden) return;
        let options;
        if (stage === 3) {
          vehicleRows = new Map(rows.filter(row => Number.isSafeInteger(Number(row.Id)) && Number(row.Id) > 0).map(row => [String(row.Id), row]));
          options = [...new Set([...vehicleRows.values()].map(row => row.Submodel || 'Base'))].map(value => ({ value, label: value }));
        } else {
          const key = ['Year', 'Make', 'Model'][stage];
          options = [...new Set(rows.map(row => String(typeof row === 'object' ? row[key] ?? row.Name ?? row.Value ?? '' : row)).filter(Boolean))]
            .map(value => ({ value, label: value }));
        }
        options.sort(stage === 0 ? (a, b) => Number(b.value) - Number(a.value) : (a, b) => a.label.localeCompare(b.label));
        setOptions(target, options, placeholders[stage]);
        if (!options.length) message.textContent = 'No vehicles found for this selection.';
        if (stage === 0 && options.length) target.focus();
      } catch (error) {
        if ((error.name === 'AbortError' && !timedOut) || token !== request || panel.hidden) return;
        setOptions(target, [], placeholders[stage]);
        message.textContent = 'Vehicle choices are unavailable. Please try again.';
        retry.hidden = false;
      } finally { clearTimeout(timer); }
    };

    let nativePicker = null;
    const nativeHost = document.createElement('div');
    nativeHost.className = 'mayhem-header-vehicle__fields twg-native-vehicle-fields';
    nativeHost.hidden = true;
    nativeHost.style.display = 'none';
    panel.querySelector('.mayhem-header-vehicle__panel-heading').after(nativeHost);
    chip.mayhemCancelPicker = () => {
      ++request; controller?.abort(); searchRemainder = null;
      nativePicker?.destroy(); nativePicker = null;
    };
    chip.mayhemPreparePicker = () => {
      window.dispatchEvent(new CustomEvent('mayhem:picker-opened', {detail:{surface:'header'}}));
      searchRemainder = null;
      if (window.TWGFitmentPreview?.status().enabled && window.TWGFitmentPreview.status().mode==='twg_app_draft') {
        ++request; controller?.abort();
        panel.querySelector('.mayhem-header-vehicle__fields:not(.twg-native-vehicle-fields)').hidden = true;
        panel.querySelector('.mayhem-header-vehicle__fields:not(.twg-native-vehicle-fields)').style.display = 'none';
        [applyButton,message,retry].forEach(element => {element.hidden=true;});
        nativeHost.hidden = false;
        nativeHost.style.display = 'grid';
        nativePicker?.destroy();
        nativePicker = window.TWGFitmentPreview.mountVehicleSelector(nativeHost,{showResults:false});
        return;
      }
      applyButton.disabled = true;
      fields.forEach((field, index) => setOptions(field, [], placeholders[index]));
      showBodyField(false);
      load(0);
    };
    openButton.addEventListener('click', () => window.mayhemOpenVehiclePicker?.(openButton, chip));
    const selectedButton = chip.querySelector('[data-mayhem-header-vehicle-selected]');
    selectedButton.addEventListener('click', event => {
      event.preventDefault();
      window.mayhemOpenVehiclePicker?.(selectedButton, chip);
    });
    chip.querySelector('[data-mayhem-header-vehicle-change]')?.addEventListener('click', event => window.mayhemOpenVehiclePicker?.(event.currentTarget, chip));
    panel.querySelector('[data-mayhem-header-vehicle-close]').addEventListener('click', () => close(chip, true));
    retry.addEventListener('click', () => load(currentStage));
    year.addEventListener('change', () => { resetAfter(0); showBodyField(false); if (year.value) load(1); });
    make.addEventListener('change', () => { resetAfter(1); showBodyField(false); if (make.value) load(2); });
    model.addEventListener('change', () => { resetAfter(2); showBodyField(false); if (model.value) load(3); });
    trim.addEventListener('change', () => { resetAfter(3); showBodyField(false); if (trim.value) load(4); });
    vehicle.addEventListener('change', () => {
      applyButton.disabled = !vehicleRows.has(vehicle.value);
    });
    applyButton.addEventListener('click', () => {
      const row = vehicleRows.get(vehicle.value);
      if (!row) return;
      window.dispatchEvent(new CustomEvent('mayhem:picker-completed', {detail:{surface:'header'}}));
      const selected = {
        id: String(row.Id), year: String(row.Year), make: row.Make, model: row.Model,
        submodel: row.Submodel || 'Base', body: row.Body, bed: row.Bed,
        photoUrl: row.mayhemPhotoUrl || null
      };
      if (selected.photoUrl) {
        try { localStorage.setItem('mayhem:vehicle-photo:' + selected.id, selected.photoUrl); } catch { /* Photo caching is optional. */ }
      }
      for (const store of [localStorage, sessionStorage]) {
        try {
          store.setItem('mayhem:selected-vehicle-id', selected.id);
          store.setItem('mayhem:selected-vehicle', JSON.stringify(selected));
        } catch (error) { /* Continue with the other storage option. */ }
      }
      if (searchRemainder !== null) {
        const tokens = [row.Submodel, row.Body, row.Bed, ...String(vehicle.selectedOptions[0]?.textContent || '').split('·').map(value => value.trim())].filter(Boolean);
        const remainder = window.MayhemWheelSearch.stripVehicleDetails(searchRemainder, tokens);
        const destination = new URL('/search', location.origin);
        destination.searchParams.set('q', remainder);
        destination.searchParams.set('type', 'product');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) destination.searchParams.set('preview_theme_id', preview);
        location.assign(destination.href);
        return;
      }
      update();
      close(chip, true);
      window.dispatchEvent(new CustomEvent('mayhem:vehicle-changed', { detail: { id: selected.id, vehicle: selected, source: 'header', selection_location: window.MayhemAnalytics?.vehicleSource(panel) || 'header', navigate: false } }));
      if (location.pathname === '/') {
        const destination = new URL('/collections/all-wheels', location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) destination.searchParams.set('preview_theme_id', preview);
        location.assign(destination.href);
      }
    });
    chip.querySelector('[data-mayhem-header-vehicle-clear]').addEventListener('click', clearSelection);
    panel.querySelector('[data-mayhem-picker-clear]')?.addEventListener('click', () => { close(chip); clearSelection(); });
  };

  chips.forEach(initializeChip);
  window.mayhemPrefillSearchVehicle = input => chips.find(chip => !panels.get(chip).hidden)?.mayhemPrefillSearch?.(input);
  const openRequestedMobilePicker = () => {
    if (!mobilePickerRequested) return;
    const menu = document.querySelector('#Details-menu-drawer-container');
    const chip = menu?.querySelector('.mayhem-header-vehicle-mobile');
    const button = chip?.querySelector('[data-mayhem-header-vehicle-open]');
    if (!menu?.open || !button || button.hidden || openButtons.get(chip) !== button) return;
    mobilePickerRequested = false;
    button.click();
  };
  document.addEventListener('click', event => {
    if (event.target.closest('a[href*="/pages/visualizer"]')) syncVisualizerLinks();
    if (event.target.closest('[data-mayhem-mobile-vehicle-clear]')) clearSelection();
    const trigger = event.target.closest('[data-mayhem-mobile-vehicle-select], [data-mayhem-mobile-vehicle-details], [data-mayhem-mobile-vehicle-change]');
    if (trigger) window.mayhemOpenVehiclePicker?.(trigger);
  });
  const syncChips = () => {
    const current = [...document.querySelectorAll('[data-mayhem-header-vehicle]')];
    const added = current.filter(chip => openButtons.get(chip) !== chip.querySelector('[data-mayhem-header-vehicle-open]'));
    if (!added.length) {
      const mobileStatus = document.querySelector('[data-mayhem-mobile-vehicle-status]');
      const saved = read(localStorage) || read(sessionStorage);
      const staleChip = current.some(chip => Boolean(saved) !== !chip.querySelector('[data-mayhem-header-vehicle-selected]').hidden ||
        (saved && !chip.querySelector('[data-mayhem-header-vehicle-name]').textContent));
      if (mobileStatus && (mobileStatus.dataset.mayhemInitialized !== 'true' || staleChip)) {
        mobileStatus.dataset.mayhemInitialized = 'true';
        update();
      }
      openRequestedMobilePicker();
      return;
    }
    chips = current;
    added.forEach(chip => {
      openButtons.set(chip, chip.querySelector('[data-mayhem-header-vehicle-open]'));
      panels.set(chip, chip.querySelector('[data-mayhem-header-vehicle-panel]'));
      initializeChip(chip);
    });
    const mobileStatus = document.querySelector('[data-mayhem-mobile-vehicle-status]');
    if (mobileStatus) mobileStatus.dataset.mayhemInitialized = 'true';
    update();
    openRequestedMobilePicker();
  };
  new MutationObserver(syncChips).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', event => {
    if (event.target.closest('#Details-menu-drawer-container > summary')) setTimeout(syncChips, 0);
  }, true);

  const positionPicker = surface => {
    const mobile = matchMedia('(max-width:749px)').matches;
    surface.classList.toggle('mayhem-vehicle-picker-sheet', mobile);
    if (mobile) {
      surface.style.removeProperty('left');
      surface.style.removeProperty('top');
      surface.style.removeProperty('max-height');
      return;
    }
    const anchor = surface.mayhemOpener;
    if (!anchor?.isConnected) return;
    const rect = anchor.getBoundingClientRect();
    const width = Math.min(380, innerWidth - 24);
    const top = Math.max(12, Math.min(rect.bottom + 8, innerHeight - 180));
    surface.style.left = Math.max(12, Math.min(rect.left, innerWidth - width - 12)) + 'px';
    surface.style.top = top + 'px';
    surface.style.maxHeight = Math.max(160, innerHeight - top - 12) + 'px';
  };
  window.mayhemOpenVehiclePicker = (anchor, requestedChip) => {
    const chip = requestedChip || chips.find(item => item.classList.contains('mayhem-header-vehicle'));
    const surface = document.querySelector('[data-mayhem-collection-vehicle-dialog]');
    if (!chip || !anchor || !surface) return false;
    const panel = panels.get(chip);
    if (!panel.hidden && panel.mayhemOpener === anchor) { close(chip, true); return true; }
    chips.forEach(item => close(item));
    document.body.appendChild(surface);
    surface.classList.add('mayhem-vehicle-picker-surface');
    surface.id ||= 'mayhem-shared-vehicle-picker';
    surface.mayhemOpener = anchor;
    panel.mayhemOpener = anchor;
    anchor.setAttribute('aria-expanded', 'true');
    anchor.setAttribute('aria-controls', surface.id);
    anchor.setAttribute('aria-haspopup', 'dialog');
    panel.removeAttribute('role');
    panel.hidden = false;
    surface.appendChild(panel);
    positionPicker(surface);
    if (matchMedia('(max-width:749px)').matches) surface.showModal();
    else surface.show();
    chip.mayhemPreparePicker();
    panel.querySelector('[data-mayhem-header-vehicle-close]').focus();
    if (surface.dataset.mayhemInitialized !== 'shared') {
      surface.dataset.mayhemInitialized = 'shared';
      surface.addEventListener('close', () => {
        if (!surface.open) chips.forEach(item => {
          if (panels.get(item)?.parentElement === surface) close(item, true);
        });
      });
      surface.addEventListener('click', event => {
        if (event.target !== surface) return;
        const rect = surface.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) chips.forEach(item => close(item, true));
      });
    }
    return true;
  };
  document.addEventListener('click', event => chips.forEach(chip => {
    const panel = panels.get(chip);
    if (!panel || panel.hidden || panel.contains(event.target) || panel.mayhemOpener?.contains(event.target)) return;
    close(chip);
  }));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const chip = chips.find(item => !panels.get(item)?.hidden);
    if (chip) { event.preventDefault(); close(chip, true); }
  });
  window.addEventListener('resize', () => {
    const chip = chips.find(item => !panels.get(item)?.hidden);
    if (!chip) return;
    const surface = panels.get(chip).parentElement;
    const wasMobile = surface.classList.contains('mayhem-vehicle-picker-sheet');
    const mobile = matchMedia('(max-width:749px)').matches;
    if (wasMobile !== mobile) {
      surface.close();
      positionPicker(surface);
      if (mobile) surface.showModal(); else surface.show();
    } else positionPicker(surface);
  });
  document.addEventListener('scroll', event => {
    const surface = document.querySelector('.mayhem-vehicle-picker-surface[open]');
    if (surface && !surface.contains(event.target)) positionPicker(surface);
  }, true);
  window.addEventListener('twg:vehicle-changed', () => { chips.forEach(chip=>close(chip)); update(); });
  window.addEventListener('mayhem:vehicle-changed', event => {
    update();
    if (event.detail?.navigate === false || window.MayhemSupport?.selectingVehicle || !event.detail?.id || !['header', 'lookup'].includes(event.detail.source) ||
      !window.matchMedia('(max-width: 749px)').matches ||
      ['/collections/all-wheels', '/pages/visualizer', '/search'].includes(window.location.pathname.replace(/\/$/, ''))) return;
    const destination = new URL('/collections/all-wheels', window.location.origin);
    destination.searchParams.set('fitment', 'matches');
    destination.searchParams.set('sort_by', 'manual');
    const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
    window.location.assign(destination.href);
  });
  window.addEventListener('storage', event => {
    if (event.key === null || ['mayhem:selected-vehicle-id', 'mayhem:selected-vehicle'].includes(event.key)) {
      try {
        for (const key of ['mayhem:selected-vehicle-id', 'mayhem:selected-vehicle']) {
          const value = localStorage.getItem(key);
          if (value === null) sessionStorage.removeItem(key);
          else sessionStorage.setItem(key, value);
        }
      } catch {}
      const saved = read(localStorage) || read(sessionStorage);
      window.dispatchEvent(new CustomEvent('mayhem:vehicle-changed', {
        detail: { id: saved?.id || null, vehicle: saved?.vehicle || null, source: 'storage' }
      }));
    } else update();
  });
  window.addEventListener('pageshow', () => { syncChips(); update(); });
  update();
})();





